import TagAPI from './tag-api';

export { TagData } from './tag-api';
export default TagAPI;
